 
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { AUTH_PATHS_ABSOLUTE } from '@modules/auth/auth.paths';

@Injectable({
  providedIn: 'root',
})
export class OrgGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    try {
      if (!this.authService.isLoggedIn()) {
        return this.router.parseUrl(AUTH_PATHS_ABSOLUTE.AUTH_ROOT);
      }
      if (!this.authService.userInfo) {
        await this.authService.getUserInformation();
      }

      if (
        this.authService.userInfo?.scopes.includes('orgAdmin') ||
        this.authService.userInfo?.scopes.includes('caseManager')
      ) {
        return true;
      }
    } catch (error) {
      this.authService.logout();
      throw error;
    }

    this.authService.logout();
    return this.router.parseUrl(AUTH_PATHS_ABSOLUTE.AUTH_ROOT);
  }
}
